export const TABLE_CELL_CLASS = "px-3 py-2.5";
export const TABLE_HEAD_CLASS =
  "border-b border-gray-200 bg-gray-50 text-[10px] font-semibold uppercase tracking-wide text-gray-500";

export const ACTION_ICON_BTN =
  "inline-flex h-[26px] w-[26px] items-center justify-center rounded-md border transition focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:cursor-wait disabled:opacity-60";

export const ACTION_VARIANTS = {
  blue: "border-[#007BFF]/25 bg-[#007BFF]/5 text-[#007BFF] hover:bg-[#007BFF]/10 focus:ring-[#007BFF]/30",
  red: "border-red-200/80 bg-red-50/80 text-red-600 hover:bg-red-50 focus:ring-red-200",
  green: "border-emerald-200/80 bg-emerald-50/80 text-emerald-600 hover:bg-emerald-50 focus:ring-emerald-200",
  slate: "border-gray-200 bg-gray-50 text-gray-500 hover:bg-gray-100 focus:ring-gray-200",
  amber:
    "border-amber-200/80 bg-amber-50/80 text-amber-700 hover:bg-amber-50 focus:ring-amber-200",
};

export const FILTER_CARD_CLASS =
  "overflow-hidden rounded-[12px] border border-[#E5E7EB] bg-white p-3 shadow-sm sm:p-4";

export const FILTER_PANEL_INNER_CLASS = "rounded-lg bg-[#F1F5F9] p-3";

export const BADGE_BASE =
  "inline-flex rounded-full px-2.5 py-0.5 text-[10px] font-semibold";

export function getRoleBadgeClass(role = "") {
  const map = {
    "Super Admin": "bg-violet-100 text-violet-700",
    Admin: "bg-blue-100 text-blue-700",
    User: "bg-slate-100 text-slate-600",
  };
  return map[String(role).trim()] || "bg-gray-100 text-gray-600";
}

export function getStatusBadgeClass(active) {
  return active ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700";
}

export function getIpCheckBadgeClass(value) {
  const enabled =
    value === "True" || value === true || value === 1 || value === "1";
  return enabled ? "bg-sky-100 text-sky-700" : "bg-gray-100 text-gray-500";
}
